module.exports = __webpack_public_path__ + "img/dashboard-primary.a9dfd6ce.svg";